import { Dialog } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { POPOVER_DATA } from '@app/shared/modules/template/components/popover';
import { notNull } from '@app/shared/utils';
import { TranslateService } from '@ngx-translate/core';
import { format } from 'date-fns';
import * as XLSX from 'xlsx';
import { FilterStatusEnum } from '../../pages/report/report.component';
import { ModalDisplayChartComponent } from './../modal-display-chart/modal-display-chart.component';

@Component({
  templateUrl: './popover-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PopoverReportComponent {
  private readonly _dialog = inject(Dialog);
  private readonly _translateService = inject(TranslateService);
  public readonly data = inject(POPOVER_DATA);
  public readonly FilterStatusEnum = FilterStatusEnum;

  public onOpenModal() {
    this._dialog
      .open<boolean>(ModalDisplayChartComponent, {
        data: this.data.chartData,
      })
      .closed.pipe(notNull());
  }

  public onExportExcel() {
    const tituloRel =
      this._translateService.instant('trilhas.relatorio.exportar') +
      ' - ' +
      format(new Date(), 'dd/MM/yyyy').toString();
    const element = document.getElementById('tableReport') as HTMLTableElement;
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws);
    XLSX.writeFile(wb, `${tituloRel}.xlsx`);
  }
}
